import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { GuiaListMem } from "../../guias/list/listmem";
import { DatosDocumentacion } from "./datosdocumentacion";
import { onImprimirDocumentacion } from "../logic";
type Entity = models.DocumentacionDTO;
export interface Props {
    value: Entity;
}

const Imprimir = kea.defaultProps(kea.Button, { 
    children: "Imprimir guias", 
    iconClass: fa("print"),
    style: "info"
});

/**
* Componente para editar un Entity
*/
export class DocumentacionFormNoRx extends React.PureComponent<Props> {
    getField = formfields(() => this.props);

    get rules(): validation.Rules<Entity> {
        return {};
    }

    onImprimir = async () => {
        await onImprimirDocumentacion(this.props.value.IdRegistro);
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;


        return (
            <div>
                <kea.Title 
                    titulo="Ver documentacion" 
                    onRegresar={() => history.go("/operativa/documentaciones")}
                    >
                    <Imprimir onClick={this.onImprimir} />
                </kea.Title>
                
                <DatosDocumentacion value={value} />               

                <div className="row">
                    <div className="col-md-12">
                    <GuiaListMem value={value.Guias} />
                    </div>
                </div>
            </div>);
    }
}

export const DocumentacionForm = componentToRx(DocumentacionFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/documentacion/edit/form.tsx